import { Icon } from "leaflet";

import marker1 from "../images/marker/marker1.svg";
import marker2 from "../images/marker/marker2.svg";
import marker3 from "../images/marker/marker3.svg";
import marker4 from "../images/marker/marker4.svg";
import marker5 from "../images/marker/marker5.svg";
import marker6 from "../images/marker/marker6.svg";
import marker7 from "../images/marker/marker7.svg";
import marker8 from "../images/marker/marker8.svg";
import marker9 from "../images/marker/marker9.svg";
import marker10 from "../images/marker/marker10.svg";
import marker11 from "../images/marker/marker11.svg";
import marker12 from "../images/marker/marker12.svg";
import marker13 from "../images/marker/marker13.svg";
import marker14 from "../images/marker/marker14.svg";
import marker15 from "../images/marker/marker15.svg";
import marker16 from "../images/marker/marker16.svg";
import marker17 from "../images/marker/marker17.svg";
import marker18 from "../images/marker/marker18.svg";
import marker19 from "../images/marker/marker19.svg";
import marker20 from "../images/marker/marker20.svg";

import markerHistoric from "../images/marker/marker-h.svg";
import positionMarker from "../images/marker/positionMarker.svg";

export const markers = [
  marker1,
  marker2,
  marker3,
  marker4,
  marker5,
  marker6,
  marker7,
  marker8,
  marker9,
  marker10,
  marker11,
  marker12,
  marker13,
  marker14,
  marker15,
  marker16,
  marker17,
  marker18,
  marker19,
  marker20,
].map((marker) => {
  return new Icon({
    iconUrl: marker,
    shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12.5, 41],
    shadowAnchor: [12.5, 41],
  });
});

export const mH = new Icon({
  iconUrl: markerHistoric,
  iconSize: [25, 41],
  iconAnchor: [12.5, 41],
});

export const pM = new Icon({
  iconUrl: positionMarker,
  iconSize: [25, 41],
  iconAnchor: [12.5, 41],
});
